/* Hervis Theme — das kleine bisschen JavaScript, das das Theme überhaupt
   braucht. Kein Framework, keine Bibliothek: alles hier läuft direkt im
   Browser und bleibt lesbar.

   Regel für neue Funktionen: erst versuchen, es in CSS zu lösen. Nur was
   ohne JavaScript nicht geht (Zustände, Tastatur, Daten nachladen), gehört
   in diese Datei oder in den {% javascript %}-Block einer Section. */

(() => {
  const reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Auftauchen beim Scrollen — Rückfallebene für Browser ohne
        scroll-driven animations (siehe critical.css § 10). */
  const unterstuetztScrollAnimation = CSS.supports('animation-timeline', 'view()');

  if (!unterstuetztScrollAnimation && !reduziert) {
    const beobachter = new IntersectionObserver(
      (eintraege) => {
        eintraege.forEach((eintrag) => {
          if (!eintrag.isIntersecting) return;
          eintrag.target.classList.add('is-visible');
          beobachter.unobserve(eintrag.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 },
    );

    const beobachte = (wurzel) =>
      wurzel.querySelectorAll('.reveal:not(.is-visible)').forEach((el) => beobachter.observe(el));

    beobachte(document);
    document.addEventListener('shopify:section:load', (e) => beobachte(e.target));
  } else {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  /* 2. Warenkorb-Zähler aktuell halten, ohne die Seite neu zu laden.
        Jede Section, die den Warenkorb ändert, meldet das so:
        document.dispatchEvent(new CustomEvent('hervis:warenkorb', { detail: { item_count } }))
        Ohne item_count wird /cart.js gefragt. Auch beim Zurückblättern
        (pageshow aus dem Verlaufs-Cache) wird nachgezählt. */
  const zaehlerSetzen = (anzahl) => {
    document.querySelectorAll('[data-warenkorb-anzahl]').forEach((el) => {
      el.textContent = anzahl;
      el.hidden = anzahl === 0;
    });
  };
  const zaehlerAktualisieren = async (e) => {
    const gemeldet = e?.detail?.item_count;
    if (Number.isFinite(gemeldet)) {
      zaehlerSetzen(gemeldet);
      return;
    }
    try {
      const antwort = await fetch(
        window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart.js` : '/cart.js',
      );
      if (!antwort.ok) return;
      const warenkorb = await antwort.json();
      zaehlerSetzen(warenkorb.item_count);
    } catch {
      /* Offline oder abgebrochen — der serverseitig gerenderte Stand bleibt stehen. */
    }
  };
  document.addEventListener('hervis:warenkorb', zaehlerAktualisieren);
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) zaehlerAktualisieren();
  });

  /* 3. Schubladen und Overlays: ein <dialog> öffnen/schließen, ohne dass
        jede Section die Tastatur- und Fokus-Logik neu schreibt.
        <button data-oeffnet="mein-dialog">  →  <dialog id="mein-dialog">
        Schließen: [data-schliesst] im Dialog, Esc (nativ) oder — bei
        dialog.desktop-dialog ohne data-bleibt — ein Klick auf den
        abgedunkelten Hintergrund.
        Der Fokus geht danach an den Knopf zurück, der geöffnet hat.
        Die Seite dahinter sperrt CSS (critical.css: html:has(dialog[open]:modal)). */
  const oeffner = new WeakMap();

  /* Liegt der Punkt auf dem abgedunkelten Hintergrund eines offenen
     dialog.desktop-dialog? Ziel ist dann der Dialog selbst, und der Punkt
     liegt außerhalb seines Rahmens (Polsterung zählt als drinnen). */
  const aufHintergrund = (dialog, e) => {
    /* data-bleibt: Formulare (Adress-Editor) schließt ein Klick daneben
       nicht — sonst wäre das Getippte mit einem Fehlklick weg. */
    if (
      !(dialog instanceof HTMLDialogElement) ||
      !dialog.open ||
      !dialog.classList.contains('desktop-dialog') ||
      dialog.hasAttribute('data-bleibt')
    ) {
      return false;
    }
    const rahmen = dialog.getBoundingClientRect();
    return (
      e.clientX < rahmen.left ||
      e.clientX > rahmen.right ||
      e.clientY < rahmen.top ||
      e.clientY > rahmen.bottom
    );
  };

  /* Wo der Druck begann: Wer im Dialog Text markiert und erst jenseits des
     Rands loslässt, löst einen click auf dem Dialog aus — der darf nicht
     schließen. Geschlossen wird nur, wenn Druck UND Klick draußen lagen. */
  let gedruecktAuf = null;
  document.addEventListener(
    'pointerdown',
    (e) => {
      gedruecktAuf = aufHintergrund(e.target, e) ? e.target : null;
    },
    true,
  );

  document.addEventListener('click', (e) => {
    const druckDraussen = gedruecktAuf;
    gedruecktAuf = null;

    const knopf = e.target.closest('[data-oeffnet]');
    if (knopf) {
      const ziel = document.getElementById(knopf.dataset.oeffnet);
      if (ziel instanceof HTMLDialogElement) {
        e.preventDefault();
        if (!ziel.open) {
          oeffner.set(ziel, knopf);
          ziel.showModal();
        }
      }
      return;
    }

    const schliesser = e.target.closest('[data-schliesst]');
    if (schliesser) {
      schliesser.closest('dialog')?.close();
      return;
    }

    /* Klick auf den Hintergrund schließt — aber nur, wenn auch der Druck
       dort begann (siehe oben). */
    const dialog = e.target;
    if (druckDraussen === dialog && aufHintergrund(dialog, e)) dialog.close();
  });

  document.addEventListener(
    'close',
    (e) => {
      if (!(e.target instanceof HTMLDialogElement)) return;
      const knopf = oeffner.get(e.target);
      oeffner.delete(e.target);
      if (knopf?.isConnected) knopf.focus({ preventScroll: true });
    },
    true,
  );

  /* 4. Ab in die App (Runde 4, RUNDE4 § 2.5) — ohne Sackgasse.
        <a href="{Download-Seite}" data-app-oeffnen data-app-pfad="/product/123">
          → öffnet die App an dieser Stelle, sonst die Download-Seite.
        <a href="{Download-Seite}" data-app-laden> → Store bzw. Download-Seite.
        Ohne JavaScript führt der href zur Download-Seite.
        · Desktop: nie das Schema (täte nichts) — die Download-Seite im neuen Tab.
        · Android: intent:// mit browser_fallback_url; Chrome fällt selbst zurück.
        · iOS: hervis:///<route>; bleibt die Seite 1,5 s sichtbar, war keine
          App da → Download-Seite (Muster aus apps/web/app/go/page.jsx).
          Universal Links hat die App nicht, darum kann Safari kurz
          „Adresse ungültig" zeigen (Owner-Frage 9).
        Ziele aus <script id="app-ziele"> (layout/theme.liquid): Store-Links
        aus den Theme-Einstellungen gewinnen, sonst die Download-Seite.
        window.hervisApp = { oeffnen(pfad), ladenUrl(), erlaubt(pfad), plattform } */
  const APP_SEITE = 'https://download.hervis.app';
  /* Nur Routen der App (main), die etwas zeigen — nie profile, p/…,
     community, sport-profile, payment-methods (Demo) oder brand/…;
     onboarding nur als Fragebogen (+500, sections/willkommen.liquid). */
  const APP_ERLAUBT =
    /^\/(?:(?:product|collection)\/[A-Za-z0-9_-]+|stores(?:\/[a-z0-9-]+)?|orders(?:\/\d+)?|shop|browse|brands|cart|wishlist|loyalty|addresses|settings|legal|account(?:\/data)?|consents|foot-scan|onboarding\?mode=quiz|search(?:\?q=[^#&]{0,120})?|live\?post=gid%3A%2F%2Fshopify%2FMetaobject%2F\d+)?$/;
  const appZiele = (() => {
    try {
      return JSON.parse(document.getElementById('app-ziele')?.textContent || '{}') || {};
    } catch {
      return {};
    }
  })();
  const kennung = navigator.userAgent;
  const istIos =
    /iP(?:hone|od|ad)/.test(kennung) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const istAndroid = !istIos && /Android/i.test(kennung);
  const plattform = istIos ? 'ios' : istAndroid ? 'android' : 'desktop';

  const ladenUrl = () =>
    (istIos && appZiele.ios) || (istAndroid && appZiele.android) || appZiele.seite || APP_SEITE;
  const erlaubt = (pfad) => typeof pfad === 'string' && APP_ERLAUBT.test(pfad);

  /* Filiale und Bestellung stehen im Anker der Seite, nicht im Pfad. */
  const verfeinern = (pfad) => {
    if (pfad === '/stores') {
      const treffer = location.hash.match(/[#&]filiale=([a-z0-9-]+)/);
      if (treffer) return '/stores/' + treffer[1];
    }
    if (pfad === '/orders') {
      const treffer = location.hash.match(/^#bestellung-(\d+)$/);
      if (treffer) return '/orders/' + treffer[1];
    }
    return pfad;
  };

  function appOeffnen(pfad = '/') {
    const fein = verfeinern(pfad);
    const ziel = erlaubt(fein) ? fein : '/';
    const laden = ladenUrl();

    if (plattform === 'desktop') {
      window.open(laden, '_blank', 'noopener');
      return;
    }
    if (plattform === 'android') {
      location.href =
        'intent://' +
        ziel +
        '#Intent;scheme=hervis;package=com.hervis.sports;S.browser_fallback_url=' +
        encodeURIComponent(laden) +
        ';end';
      return;
    }

    let weg = false;
    const merken = () => {
      weg = true;
      try {
        localStorage.setItem('hervis:app-da', String(Date.now()));
      } catch {
        /* Speicher gesperrt — dann sagt die App-Leiste weiter „Laden". */
      }
    };
    const sicht = () => {
      if (document.visibilityState === 'hidden') merken();
    };
    /* Die Rückfrage „In „Hervis" öffnen?" nimmt der Seite den Fokus — dann
       nicht unter ihr wegspringen. */
    const unscharf = () => {
      weg = true;
    };
    document.addEventListener('visibilitychange', sicht);
    window.addEventListener('pagehide', merken, { once: true });
    window.addEventListener('blur', unscharf, { once: true });
    setTimeout(() => {
      document.removeEventListener('visibilitychange', sicht);
      window.removeEventListener('pagehide', merken);
      window.removeEventListener('blur', unscharf);
      if (!weg && document.visibilityState === 'visible') location.href = laden;
    }, 1500);
    location.href = 'hervis://' + ziel; // → hervis:///product/… (drei Schrägstriche)
  }

  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
      return;
    if (!(e.target instanceof Element)) return;
    const oeffnenLink = e.target.closest('[data-app-oeffnen]');
    if (oeffnenLink) {
      e.preventDefault();
      appOeffnen(oeffnenLink.dataset.appPfad || '/');
      return;
    }
    /* Desktop: der Link selbst öffnet den neuen Tab (target="_blank"). */
    const ladenLink = e.target.closest('[data-app-laden]');
    if (ladenLink && plattform !== 'desktop') {
      e.preventDefault();
      location.href = ladenUrl();
    }
  });

  window.hervisApp = { oeffnen: appOeffnen, ladenUrl, erlaubt, plattform };
})();
